import { Divider, Grid, Typography, Button, Paper, CircularProgress } from '@mui/material'

import { format } from 'date-fns'
import es from 'date-fns/locale/es'

import { formatCurrency, formatDate } from 'utils/misc'

const PurchaseSummary = (props) => {
  const { information, isValid, loading } = props

  return (
    <Grid container spacing={2} my={{ md: -20 }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ fontSize: 20 }}>Resumen de compra</Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2} sx={{ maxHeight: '50vh', overflowX: 'hidden', overflowY: 'scroll' }}>
          {information?.products?.map(product => (
            <Grid item xs={12} key={product.id}>
              <Paper sx={{ background: '#F5F4F4', boxShadow: 'none', maxHeight: 200, overflow: 'scroll' }}>
                <Grid container spacing={2} p={2}>
                  <Grid item xs={8}>
                    <Typography variant="h5" noWrap>{product.name}</Typography>
                    {product.venue && <Typography color="textSecondary" variant="caption" noWrap>sede {product.venue}</Typography>}
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="h5" align="right" noWrap>{formatCurrency(product.total)}</Typography>
                  </Grid>
                  {product?.installments ? product?.installments.map(installment => (
                    <>
                      <Grid item xs={8}>
                        <Typography variant="subtitle2" color="textSecondary">*Cuota {formatDate(installment.init_date)} - {formatDate(installment.due_date)}</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h5" noWrap align="right">{formatCurrency(installment.price)}</Typography>
                      </Grid>
                    </>
                  )) : null}
                  {product?.kits ? product?.kits.map(kit => (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h5" noWrap ml={2}>{kit.name}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="textSecondary" noWrap ml={2}>Subtotal</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="h5" noWrap align="right">{formatCurrency(kit.price)}</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant="subtitle2" color="textSecondary" noWrap ml={2}>Descuentos</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h5" color="primary" noWrap align="right">{formatCurrency(kit.discount)}</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant="subtitle2" color="textSecondary" noWrap ml={2}>Total</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h5" noWrap align="right">{formatCurrency(kit.total)}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    </>
                  )) : null}
                  {formatDate(product.init_date) && formatDate(product?.due_date) ? (
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" color="textSecondary">*Cuota {formatDate(product.init_date)} - {formatDate(product.due_date)}</Typography>
                    </Grid>
                  ) : null}
                  {product?.expired_date ? (
                    <Grid item xs={12}>
                      <Typography variant="caption" display="block" color="textSecondary">Tu plan vence el {formatDate(product.expired_date)}</Typography>
                    </Grid>
                  ) : null}
                </Grid>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} container justifyContent="space-between">
        <Typography>Subtotal</Typography>
        <Typography variant="h5">{formatCurrency(information?.subtotal)}</Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="space-between">
        <Typography>Descuentos</Typography>
        <Typography variant="h5" color="primary">{formatCurrency(information?.discounts)}</Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="space-between">
        <Typography variant="h5">Total a pagar</Typography>
        <Typography variant="h5">{formatCurrency(information?.total)}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          disabled={!isValid || loading}
          type="submit"
          fullWidth
        >
          {loading ? <CircularProgress size={24} /> : 'Pagar'}
        </Button>
      </Grid>
    </Grid >
  )
}

export default PurchaseSummary
